import React from 'react';
import {Button} from "@dts-soldel/dts-react-common";
import Pages from "../../app/pages/Pages.jsx";

const StyleGuide = () => {

	return (
    <div key="styleGuide" className="style-guide">
      <h1 className="bg-primary color-white text-center">
        <span className="content">Utah.gov Header Style Guide</span>
      </h1>
      <div className="content">
        <div className="back-button">
          <Button label="back" onClick={Pages.public.home.forward} />
        </div>
        <h2>Color Palette</h2>
        <div className="palette">
          <div className="palette_box">
            <span className="palette_color"></span>
            <span className="palette_value">#F3F1F1</span>
          </div>
          <div className="palette_box">
            <span className="palette_color"></span>
            <span className="palette_value">#E4E7ED</span>
          </div>
          <div className="palette_box">
		  	<span className="palette_color"></span>
            <span className="palette_value">#ADADB0</span>
          </div>
          <div className="palette_box">
		  	<span className="palette_color"></span>
            <span className="palette_value">#535B66</span>
          </div>
          <div className="palette_box">
		  	<span className="palette_color"></span>
            <span className="palette_value">#34333A</span>
          </div>
          <div className="palette_box">
		  	<span className="palette_color"></span>  
            <span className="palette_value">#191919</span>
          </div>
          <div className="palette_box">
		  	<span className="palette_color"></span>
            <span className="palette_value">#009CDC</span>
          </div>
          <div className="palette_box">
		  	<span className="palette_color"></span>  
            <span className="palette_value">#00719E</span>
          </div>
          <div className="palette_box">
			<span className="palette_color"></span>
            <span className="palette_value">#0062B8</span>
          </div>
          <div className="palette_box">
		  	<span className="palette_color"></span> 
            <span className="palette_value">#002E5D</span>
          </div>
          <div className="palette_box">
		  	<span className="palette_color"></span>
            <span className="palette_value">#001F3D</span>
          </div>
          <div className="palette_box">
		  	<span className="palette_color"></span>
            <span className="palette_value">#293340</span>
          </div>
          <div className="palette_box">
		  	<span className="palette_color"></span>
            <span className="palette_value">#C54C2F</span>
          </div>
          <div className="palette_box">
		  	<span className="palette_color"></span>
            <span className="palette_value">#9D3C25</span>
          </div>
          <div className="palette_box">
		  	<span className="palette_color"></span>
            <span className="palette_value">#7D301D</span>
          </div>
          <div className="palette_box">
		  	<span className="palette_color"></span>
            <span className="palette_value">#FAD29A</span>
          </div>
          <div className="palette_box">
		  	<span className="palette_color"></span>
            <span className="palette_value">#ECA400</span>
          </div>
          <div className="palette_box">
		  	<span className="palette_color"></span>
            <span className="palette_value">#513E33</span>
          </div>
          <div className="palette_box">
		  	<span className="palette_color"></span>
            <span className="palette_value">#3C5E58</span>
          </div>
          <div className="palette_box">
		  	<span className="palette_color"></span>
            <span className="palette_value">#5F7C76</span>
          </div>
          <div className="palette_box">
		  	<span className="palette_color"></span>
            <span className="palette_value">#4E6460</span>
          </div>
        </div>
		<h2>Sizes</h2>
		<h3>small</h3>
		<pre>
			<code>
				{`.utah-gov-header__title {
	font-size: 16px;
}`}
			</code>
		</pre>
		<div className="box-specs">
			<img src="img/styleguide-header_32.png" alt="Header example" />
			<span className="spec">32px</span>
		</div>
		<h3>medium</h3>
		<pre>
			<code>{`.utah-gov-header__title {
	font-size: 18px;
}`}</code>
		</pre>
		<div className="box-specs">
			<img src="img/styleguide-header_50.png" alt="Header example" />
			<span className="spec">50px</span>
		</div>	
		<h3>medium-large</h3>
		<pre>
		<code>{`.utah-gov-header__title {
	font-size: 20px;
}`}</code>
		</pre>
		<div className="box-specs">
			<img src="img/styleguide-header_64.png" alt="Header example" />
			<span className="spec">64px</span>
		</div>
		<h3>large</h3>
		<pre>
		<code>{`.utah-gov-header__title {
	font-size: 22px;
}`}</code>
		</pre>
		<div className="box-specs">
			<img src="img/styleguide-header_76.png" alt="Header example" />
			<span className="spec">76px</span>
		</div>
		<h3>small</h3>
		<pre>
		<code>{`.utah-gov-header__logo-wrapper img {
	max-height: 24px;
}`}</code>
		</pre>
		<div className="box-specs">
			<img src="img/styleguide-header-logo_32.png" alt="Header example" />
			<span className="spec">32px</span>
		</div>
		<h3>medium</h3>
		<pre>
		<code>{`.utah-gov-header__logo-wrapper img {
	max-height: 32px;
}`}</code>
		</pre>
		<div className="box-specs">
			<img src="img/styleguide-header-logo_50.png" alt="Header example" />
			<span className="spec">50px</span>
		</div>	
		<h3>medium-large</h3>
		<pre>
		<code>{`.utah-gov-header__logo-wrapper img {
	max-height: 42px;
}`}</code>
		</pre>
		<div className="box-specs">
			<img src="img/styleguide-header-logo_64.png" alt="Header example" />
			<span className="spec">64px</span>
		</div>
		<h3>large</h3>
		<pre>
		<code>{`.utah-gov-header__logo-wrapper img {
	max-height: 50px;
}`}</code>
		</pre>
		<div className="box-specs">
			<img src="img/styleguide-header-logo_76.png" alt="Header example" />
			<span className="spec">76px</span>
		</div>
		<h2>Header Misuse</h2>
		<div className="box-misuse">
			<img src="img/styleguide-header_dont-1.png" alt="Header example" />
		</div>
		<div className="box-misuse">
			<img src="img/styleguide-header_dont-2.png" alt="Header example" />
			<p>Don't select a background color that contrast well with your logo</p>
		</div>
		<div className="box-misuse">
			<img src="img/styleguide-header_dont-3.png" alt="Header example" />
			<p>Find a logo with a transparent background, when customizing a header with a background color</p>
		</div>
		
      </div>
    </div>
  );
};

export default StyleGuide;
